// ⚠️ GENERATED FILE — do not edit by hand.
// Written by scripts/generate-og-manifest.mjs on every build, from the PNGs
// actually present in public/og/. A route is listed here ONLY if its image
// exists; anything absent falls back to /images/og-default.jpg via ogImageFor().
//
// This file was previously hand-maintained and listed 33 images that did not
// exist, so every og:image on the site 404'd.

export const OG_MANIFEST: Record<string, string> = {
  // No per-page OG images on disk yet — every route falls back to
  // /images/og-default.jpg, which exists. Drop PNGs into public/og/
  // named for the slugs in scripts/generate-og-manifest.mjs and they are
  // picked up on the next build.
};
